import { lazy } from "react";
import { Navigate } from "react-router-dom";

// Import auth roles and components
import AuthGuard from "./auth"; // AuthGuard for token expiry check
import { authRoles } from "./auth/authRoles";

import Loadable from "./components/Loadable";
import MatxLayout from "./components/MatxLayout/MatxLayout";

import sessionRoutes from "./views/sessions/session-routes";
import materialRoutes from "app/views/material-kit/MaterialRoutes";

// E-CHART PAGE
const UpdateDocument = Loadable(
  lazy(() => import("app/views/material-kit/tables/updatedocument"))
);
// DASHBOARD PAGE
//const Analytics = Loadable(lazy(() => import("app/views/dashboard/UploadDocument")));

// Routes configuration
const routes = [
  {
    path: "/",
    element: <Navigate to="session/signin" />,
  },
  {
    element: <MatxLayout />,
    children: [
      // Wrap the protected routes with AuthGuard
      ...materialRoutes,
      // {
      //   path: "/convertdoc",
      //   element: (
      //     // <AuthGuard>
      //       // <Analytics />
      //     // </AuthGuard>
      //   ),
      //   auth: authRoles.admin
      // },
      {
        path: "/updatedocument",
        element: (
          // <AuthGuard>
          <UpdateDocument />
          // </AuthGuard>
        ),
        auth: authRoles.editor,
      },
    ],
  },

  // Session pages route
  ...sessionRoutes,
];

export default routes;
